export { default as Details } from "./Details";
export { default as Grid } from "./Grid";
